// import ReactGA from "react-ga4";

import { BrowserRouter as Router } from "react-router-dom";

import * as Sentry from "@sentry/browser";
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { init } from "@telegram-apps/sdk-react";
import { NuqsAdapter } from "nuqs/adapters/react-router";

import { ErrorBoundary, ErrorBoundaryError } from "@/components/ErrorBoundary";

import { AuthLayer } from "./AuthLayer";
import { I18NLayer } from "./I18NLayer";
import { MainRoutes } from "./Routes";
import { TMALayer } from "./TMALayer";

if (!import.meta.env.DEV) {
  Sentry.init({
    // dsn: "https://2aeccd5bdd26471585c268cb09eea283@glitchtip.architecton.site/3",
    // environment: "production",
    dsn: "https://c4df1aa458c74e9b9b6b6bd3593799e3@glitchtip.architecton.site/6",
    environment: "development",
  });

  //   ReactGA.initialize("G-G09LBL852");
}

init();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 sec
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      placeholderData: keepPreviousData,
    },
  },
});

export const App = () => (
  <ErrorBoundary fallback={ErrorBoundaryError}>
    <QueryClientProvider client={queryClient}>
      <TMALayer>
        <I18NLayer>
          <AuthLayer>
            <NuqsAdapter>
              <Router>
                <MainRoutes />
              </Router>
            </NuqsAdapter>
          </AuthLayer>
        </I18NLayer>
      </TMALayer>
    </QueryClientProvider>
  </ErrorBoundary>
);
